import axios from "axios";
const jsonConfig = require("../../config.json");


const deleteUserByIdResponse = async (userId) => {
    let allResponse = {}
    try {
        const Response = await  axios.delete(
            jsonConfig.apiUrl + "users/"+userId, 
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        
        allResponse = Response;
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default deleteUserByIdResponse;